import React from 'react';
import { Button, Flex, Pane } from '@leverege/ui-elements';
import S from './MultiSelector.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function MultiSelector({
  values = [],
  nameKey = 'name',
  valueKey = 'value',
  onAdd,
  onRemove,
  limit = 9999
}) {
  return /*#__PURE__*/_jsxs(Pane, {
    variant: "multiSelector",
    className: S.multiSelector,
    children: [values.map(value => /*#__PURE__*/_jsx(Value, {
      value: value,
      nameKey: nameKey,
      valueKey: valueKey,
      onRemove: onRemove
    }, hashCode(JSON.stringify(value)))), values.length < limit && /*#__PURE__*/_jsx(Button, {
      variant: "multiSelectorAdd",
      icon: "@icon:create",
      onClick: onAdd,
      children: "Add"
    })]
  });
}
function Value({
  value,
  nameKey,
  valueKey,
  onRemove
}) {
  return /*#__PURE__*/_jsx(Pane, {
    variant: "multiSelectorItem",
    children: /*#__PURE__*/_jsxs(Flex, {
      variant: "row",
      justify: "space-between",
      align: "center",
      vFill: true,
      children: [/*#__PURE__*/_jsx("span", {
        className: S.multiSelectorItemLabel,
        children: typeof value === 'object' ? value[nameKey] : value
      }), /*#__PURE__*/_jsx(Button, {
        className: S.multiSelectorItemRemove,
        variant: "multiSelectorItemRemove",
        icon: "@icon:cancel",
        eventData: value,
        onClick: onRemove
      })]
    })
  });
}
function hashCode(s = '') {
  return s.split('').reduce((a, b) => {
    a = (a << 5) - a + b.charCodeAt(0);
    return a & a;
  }, 0);
}
export default MultiSelector;